import { adminClient } from './admin-client';

/**
 * POST /login → { data: user, token }. The caller is responsible for rejecting
 * non-admin accounts (see AdminAuthProvider).
 */
export async function adminLogin({ email, password }) {
  const { data } = await adminClient.post('/login', { email, password });
  return { user: data.data, token: data.token };
}

/** GET /me → { data: user }. Used to restore a persisted admin session. */
export async function fetchAdminMe() {
  const { data } = await adminClient.get('/me');
  return data.data;
}

/** POST /logout → 204. Revokes the current token server-side. */
export async function adminLogout() {
  await adminClient.post('/logout');
}
